import Head from "@modules/common/components/head";
import DemoForm from "@modules/home/contact-form";
import React from "react";

function Index() {
  return (
    <div>
      <Head /> <DemoForm />
    </div>
  );
}

export default Index;
